export default __webpack_public_path__ + "static/media/home-popup3.c25691df.jpg";